<template>
  <div v-if="this.managements.length > 0" class="calendar-compact-container">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3 mt-4">
        <i class=" fa fa-info-circle color-orange" />
        Historial de Gestiones Realizadas
      </div>
      <div class="col">
        <time-line class="mt-4 custom-time-line">
          <time-line-item
            v-for="(item, index) in filteredManagements"
            :key="index"
          >
            <template #date>
              <div class="hour-container">
                <span class="color-black font-14 font-weight-bold">
                  {{ item.createdDate | date }}
                </span>
                <div class="text-right">
                  <span class="color-gray font-12 text-right pr-4">
                    {{ item.createdDate | hour }}
                  </span>
                </div>
              </div>
            </template>
            <div id="main-info" class="row ">
              <div class="col-md-3 border-right pt-2">
                <div class="  font-weight-bold">{{ item.managementType }}</div>
              </div>
              <div class="col-md-2">
                <div class="data-label">Usuario:</div>
                <span class="data">{{ item.user }}</span>
              </div>
              <div class="col-md-5">
                <div class="data-label">Comentario:</div>
                <span class="data">{{ item.comment }}</span>
              </div>
              <div v-if="item.canDelete" class="col-md-2">
                <action-button
                  class="align-middle"
                  i="fas fa-times-circle"
                  text="Eliminar"
                  variant="outline-danger mr-3"
                  @click="handleDeleteManagement(item.id, item.managementType)"
                />
              </div>
            </div>
          </time-line-item>
        </time-line>

        <div v-if="hasMoreData" class="col-12 text-center pt-4 mt-2">
          <button
            class="bg-white btn-outline arrowButton font-18 w-30"
            @click="getNext"
          >
            <i class="far fa-angle-double-down mb-4" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@/components/common/timeline';
import { getUser } from '@/core/auth';
import {
  getManagement,
  deleteManagement as _deleteManagement,
} from '@/modules/shared/cardHandling.api';
import alert from '@/mixins/alert.mixin';
const pageSize = 2;
export default {
  name: 'CardManagementResult',
  components: {
    TimeLine,
    TimeLineItem,
  },
  mixins: [alert],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  data: () => ({
    managements: [],
    filteredManagements: [],
  }),
  computed: {
    hasMoreData() {
      return !(this.filteredManagements.length == this.managements.length);
    },
  },
  mounted() {
    this.getManagements();
  },
  methods: {
    async getManagements() {
      const { data: response } = await getManagement(this.id);
      const _user = await getUser();
      let managements = response.map((t) => ({
        ...t,
        canDelete:
          this.userHasPermissions('card.management.delete') ||
          t.userId == _user.profile.sub,
      }));
      this.managements = managements;
      this.filteredManagements = managements.slice(0, pageSize);
    },
    async handleDeleteManagement(id, name) {
      const answer = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea eliminar la gestión ${name}?`,
        'Si',
        'No'
      );
      if (answer) {
        this.deleteManagement(id);
        this.ShowToast(
          '',
          'La gestión ha sido eliminada exitosamente.',
          'success'
        );
      }
    },
    async deleteManagement(id) {
      await _deleteManagement(id)
        .then(() => {
          this.getManagements();
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    getNext() {
      let filterCount = this.filteredManagements.length;
      this.filteredManagements = [
        ...this.filteredManagements,
        ...this.managements.slice(filterCount, filterCount + pageSize),
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.border-right {
  border-right: 1px solid #d8d8d8;
}

.arrowButton {
  border: 1px solid #dedede;
  border-radius: 5px;
  opacity: 1;
  color: #2db782;
  height: 30px;
}

.custom-time-line {
  ::v-deep .w-date-fixed {
    width: 100px !important;
    margin-top: -12px !important;
  }

  ::v-deep .timeline__content--inner {
    padding-left: 20px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  ::v-deep .timeline__content:before {
    top: 20px !important;
    height: calc(100% + 20px) !important;
  }

  ::v-deep .timeline__content:after {
    top: 20px !important;
  }
}

/* overrides */
::v-deep .timeline__content {
  margin-left: 20px !important;

  .timeline__content--inner {
    background: #f7f7f7 !important;
    border: 1px solid #e2e2e2;
    border-radius: 5px;
  }

  .icon-absolute {
    left: -1.7% !important;
  }
}

@media only screen and (max-width: 768px) {
  .calendar-compact-container {
    margin: 0px 8px !important;
  }

  ::v-deep .custom-tag-badge {
    margin-left: 0px !important;
  }

  ::v-deep .timeline__container {
    width: 100% !important;
  }

  ::v-deep .timeline__content {
    .icon-absolute {
      left: -6% !important;
    }
  }
}
</style>
